import { mediaXsOnly } from 'cadenza/utils/media';
import { cadenzaSessionStorage } from 'cadenza/utils/session-storage/session-storage';
import type { DisplayState } from 'cadenza/api-client/workbook-api';

// Note: Exporting the names from the individual panel's module
// would lead to cyclic module dependencies.
export const WorkbookPanelName = {
  ANALYSIS_CONTEXT: 'd-analysis-context-panel',
  VIEW_SETTINGS: 'd-view-settings-panel',
  DATA_BROWSER: 'd-data-browser-panel'
} as const;

export type WorkbookPanelName = typeof WorkbookPanelName[keyof typeof WorkbookPanelName];

const PANELS_PARAM = 'panels';
const DISPLAY_STATE_PARAM = 'restoreDisplayState';

/**
 * Moves panel visibility settings from the optional "panels" URL param
 * to sessionStorage and removes the param from the URL.
 */
export function initializePanelVisibility () {
  // hide all sidepanels on small displays
  if (mediaXsOnly.matches) {
    Object.values(WorkbookPanelName).forEach(panelName => {
      cadenzaSessionStorage.setItem(panelName, 'false');
    });
  }
  const url = new URL(location.href);
  let panelsParam = url.searchParams.get(PANELS_PARAM);
  if (panelsParam != null) {
    const panelsToShow = panelsParam.split(',');
    Object.values(WorkbookPanelName).forEach(panelName => {
      cadenzaSessionStorage.setItem(panelName, String(panelsToShow.includes(panelName)));
    });
    url.searchParams.delete(PANELS_PARAM);
    history.replaceState(null, '', url.toString());
  }
}

export function getPanelVisibilityFromDisplayState (displayState: DisplayState) {
  const url = new URL(location.href);
  if (!mediaXsOnly.matches && url.searchParams.get(DISPLAY_STATE_PARAM) === 'true') {
    url.searchParams.delete(DISPLAY_STATE_PARAM);
    history.replaceState(null, '', url);
    return {
      [WorkbookPanelName.ANALYSIS_CONTEXT]: displayState.isAnalysisContextDisplayed,
      [WorkbookPanelName.VIEW_SETTINGS]: displayState.isDesignerDisplayed,
      [WorkbookPanelName.DATA_BROWSER]: displayState.isDataBrowserDisplayed
    };
  }
}
